import { FC } from "react";
import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";
import { NavLink } from "react-router-dom";

import { getAvailableNavGroups } from "../../../pages/home/model/admin-menu-items";
import { tokens } from "../../../shared/config/theme";

interface AdminSidebarNavProps {
  permissions: number[];
  collapsed: boolean;
}

export const AdminSidebarNav: FC<AdminSidebarNavProps> = ({
  permissions,
  collapsed,
}) => {
  const groups = getAvailableNavGroups(permissions);

  return (
    <Box
      sx={{
        flex: 1,
        overflowY: "auto",
        overflowX: "hidden",
        px: collapsed ? 1 : 1.5,
        py: 1,
      }}
    >
      {groups.map((group) => (
        <Box key={group.id} sx={{ mb: 1.5 }}>
          {!collapsed && (
            <Typography
              sx={{
                px: 1.25,
                py: 0.75,
                fontSize: 11,
                fontWeight: 600,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                color: "text.disabled",
              }}
            >
              {group.label}
            </Typography>
          )}
          <List disablePadding>
            {group.items.map((item) => {
              const Icon = item.icon;
              const button = (
                <ListItemButton
                  component={NavLink}
                  to={item.path}
                  sx={{
                    minHeight: 40,
                    borderRadius: 1.5,
                    mb: 0.25,
                    px: collapsed ? 1 : 1.25,
                    justifyContent: collapsed ? "center" : "flex-start",
                    color: "text.secondary",
                    "&.active": {
                      backgroundColor: tokens.accent.muted,
                      color: tokens.accent.soft,
                      "& .MuiListItemIcon-root": {
                        color: tokens.accent.main,
                      },
                    },
                    "&:hover": {
                      backgroundColor: tokens.navy[700],
                    },
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: collapsed ? 0 : 36,
                      color: "inherit",
                      justifyContent: "center",
                    }}
                  >
                    <Icon sx={{ fontSize: 20 }} />
                  </ListItemIcon>
                  {!collapsed && (
                    <ListItemText
                      primary={item.label}
                      slotProps={{
                        primary: {
                          fontSize: 13,
                          fontWeight: 500,
                          noWrap: true,
                        },
                      }}
                    />
                  )}
                </ListItemButton>
              );

              if (!collapsed) {
                return <Box key={item.key}>{button}</Box>;
              }

              return (
                <Tooltip key={item.key} title={item.label} placement="right">
                  {button}
                </Tooltip>
              );
            })}
          </List>
        </Box>
      ))}
    </Box>
  );
};
